import { render, staticRenderFns } from "./MainModeMaterial.vue?vue&type=template&id=df71b340&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeMaterial/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeMaterial/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports